import React, { useState } from "react";
import Header from "../Components/Header";
import Footer from "../Components/Footer";
import PageHeader from "../Components/Pageheader";
import "../assets/Css/cart.css";
import { carddetail, seller1, seller2, seller3, seller4 } from "../Constant/Index";
import { Link } from "react-router-dom";

const Cart = () => {
  const sellerstuff = [
    {
      img: seller1,
      name: "product name",
      price: "20",
      para: "We believe in natural beauty",
    },
    {
      img: seller2,
      name: "product name",
      price: "20",
      para: "We believe in natural beauty",
    },
    {
      img: seller3,
      name: "product name",
      price: "20",
      para: "We believe in natural beauty",
    },
    {
      img: seller4,
      name: "product name",
      price: "20",
      para: "We believe in natural beauty",
    },
  ];
  const products = [
    {
      imgwrapper: carddetail,
      product: "Magnesium Bath Salt",
      price: 49.0,
      quantity: 1,
      subtotal: 49.0,
    },
    {
      imgwrapper: carddetail,
      product: "Magnesium Bath Salt",
      price: 49.0,
      quantity: 1,
      subtotal: 49.0,
    },
    {
      imgwrapper: carddetail,
      product: "Magnesium Bath Salt",
      price: 49.0,
      quantity: 1,
      subtotal: 49.0,
    },
  ];

  const totalSubtotal = 49.0; // Static total
  const shipping = 20.0; // Static shipping cost
  const disscount = -10.0; // Static shipping cost
  const total = totalSubtotal + shipping;

  const [quantity, setQuantity] = useState(1);


  const handleChange = (e) => {
    const value = Math.max(1, Math.min(100, Number(e.target.value)));
    setQuantity(value);
  };
  const handleDecrement = () => {
    setQuantity((prevQuantity) => Math.max(prevQuantity - 1, 1));
  };

  const handleIncrement = () => {
    setQuantity((prevQuantity) => Math.min(prevQuantity + 1, 100));
  };
  return (
    <>
      <Header />
      <PageHeader pagename="Cart" />
      <section className="ourproduct-slider my-card-main">
        <div className="container">
          <div className="row">
            <div className="col-lg-12 mx-auto">
              <div className="row">
                <div className="col-lg-9">
                  <div className="table-wrapper table-wrappe2">
                    <div className="responsive-table">
                      <table className="table">
                        <thead>
                          <tr>
                            <th></th>
                            <th>Product Image</th>
                            <th>Product Name</th>
                            <th>Unit Price</th>
                            <th>Quantity</th>
                            <th>Sub Total</th>
                          </tr>
                        </thead>
                        <tbody>
                          {products.map((product, index) => (
                            <tr key={index}>
                              <td>
                                <div className="cancle-axe">
                                  <a href="#">
                                    <i class="fa-solid fa-xmark"></i>
                                  </a>
                                </div>
                              </td>
                              <td>
                                <img
                                  className="image-table-wrapper"
                                  src={product.imgwrapper}
                                  alt="Product"
                                />
                              </td>
                              <td>
                                <h4 className="bags">{product.product}</h4>
                              </td>
                              <td>$ {product.price}</td>
                              <td>
                                <div className="qty-wrapper-table">
                                  <div className="number">
                                    <div className="qty-box">
                                      <div className="quantity">
                                        <div className="quantity-nav">
                                          <button onClick={handleDecrement} className="quantity-button quantity-down">
                                            <i
                                              className="fa fa-minus"
                                              aria-hidden="true"
                                            ></i>
                                          </button>
                                          <input
                                            type="number"
                                            min="1"
                                            max="9"
                                            step="1"
                                            value={quantity}
                                            onChange={handleChange}
                                            readOnly
                                          />
                                          <button onClick={handleIncrement} className="quantity-button quantity-up">
                                            <i
                                              className="fa fa-plus"
                                              aria-hidden="true"
                                            ></i>
                                          </button>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </td>
                              <td>${product.subtotal.toFixed(2)}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
                <div className="col-lg-3 p-0">
                  <div className="row">
                    <div className="col-lg-12">
                      <div className="cart-total">
                        <div className="main-vart-heading">
                          <h5 className="heading-wrapper-cart borde-bottom pb-2">
                            Cart Totals
                          </h5>
                          <div className="sub-total wrapper-total">
                            <h6>Subtotal :</h6>
                            <h6 className="dollar-card-italic">
                              $ {totalSubtotal.toFixed(2)}
                            </h6>
                          </div>
                          <div className="shipping-total wrapper-total">
                            <h6>Shipping Cost :</h6>
                            <h6 className="dollar-card-italic">
                              $ {shipping.toFixed(2)}
                            </h6>
                          </div>
                          <div className="shipping-total wrapper-total">
                            <h6>Disscount Code :</h6>
                            <h6 className="dollar-card-italic">
                              $ {disscount.toFixed(2)}
                            </h6>
                          </div>
                          <div className="total wrapper-total">
                            <h6>Total Amount :</h6>
                            <h6 className="dollar-card-italic">
                              $ {total.toFixed(2)}
                            </h6>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row mt-4">
                <div className="col-lg-2">
                  <Link to="" className="update-btn">
                    Update
                  </Link>
                </div>
                <div className="col-lg-8">
                  <div
                    className="promocode"
                    style={{
                      opacity: "0",
                    }}
                  >
                    <input type="text" placeholder="Promo Code" />
                    <Link to="" className="btn-all-wrapper">
                      Apply
                    </Link>
                  </div>
                </div>
                <div className="col-lg-2">
                  <Link
                    to="/Checkout"
                    className="btn-all-wrapper w-100 primary-color-proceed"
                  >
                    Proceed To Checkout
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* ================================== */}
       {/* Related Product Section  */}
       <section className="Related-Prdocuts-sec">
        <div className="container">
          <div className="best-seller-heading mt-4">
            <h2 className="primary-color">Related Products</h2>
          </div>
          <div className="row">
            {sellerstuff?.map((data, sellerindex) => {
              return (
                <>
                  <div className="col-md-3" key={sellerindex}>
                    <div className="seller-all">
                      <div className="seller-img">
                        <img src={data?.img} className="img-fluid" />
                        <div className="add-to-cart">
                          <span className="primary-color">
                            {" "}
                            <i
                              class="fa fa-shopping-basket"
                              aria-hidden="true"
                            ></i>
                            <button className="priamry-color">
                              add to cart
                            </button>
                          </span>
                          <span className="primary-color primary-heart">
                            <i class="fa fa-heart" aria-hidden="true"></i>
                          </span>
                        </div>
                      </div>
                      <div className="seller-head-para">
                        <h3 className="primary-color">
                          {data?.name} <span> | {data?.price}</span>
                        </h3>
                        <p>{data?.para}</p>
                      </div>
                      <div className="seller-stars">
                        <ul>
                          <li>
                            <i
                              class="fa fa-star primary-color"
                              aria-hidden="true"
                            ></i>
                          </li>
                          <li>
                            <i
                              class="fa fa-star primary-color"
                              aria-hidden="true"
                            ></i>
                          </li>
                          <li>
                            <i
                              class="fa fa-star primary-color"
                              aria-hidden="true"
                            ></i>
                          </li>
                          <li>
                            <i
                              class="fa fa-star primary-color"
                              aria-hidden="true"
                            ></i>
                          </li>
                          <li>
                            <i
                              class="fa fa-star extra-color-6"
                              aria-hidden="true"
                            ></i>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </>
              );
            })}
          </div>
        </div>
      </section>
      {/* =========================== */}
      <Footer />
    </>
  );
};

export default Cart;
